import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-attachment",
  templateUrl: "./attachment.component.html",
  styleUrls: ["./attachment.component.scss"],
})
export class AttachmentComponent {
  photoPreview: string | null = null;
  selectedFileName: string = "";
  selectedFiles: File[] = [];
  comment: string = "";

  constructor(private dialogRef: MatDialogRef<AttachmentComponent>) {}

  // ── File Upload ──────────────────────────────────
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);
      this.selectedFileName =
        this.selectedFiles.length === 1
          ? this.selectedFiles[0].name
          : `${this.selectedFiles.length} files selected`;

      // Preview first image if it's an image file
      const firstFile = this.selectedFiles[0];
      if (firstFile.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.photoPreview = e.target?.result as string;
        };
        reader.readAsDataURL(firstFile);
      }
    }
  }

  openCamera(): void {
    console.log("تجهيز الكاميرا...");
    // TODO: implement camera integration
  }

  capturePhoto(): void {
    console.log("إلتقاط الصورة...");
    // TODO: implement capture logic
  }

  // ── Submit ────────────────────────────────────────
  onSubmit(): void {
    const payload = {
      files: this.selectedFiles,
      comment: this.comment,
    };
    console.log("إضافة مرفق:", payload);
    this.dialogRef.close(payload);
  }

  // ── Close ─────────────────────────────────────────
  onClose(): void {
    this.dialogRef.close(null);
  }
}
